import type { HNOppgaveFrontend } from "../types/Resources.d.ts";
import { oppgaveFrontendProject } from "../types/project-name-constants";

import LanguageLocales from "@helsenorge/core-utils/constants/languages";
import {
  createResourcesApi,
  getModifiedResourcesForTest,
} from "@helsenorge/framework-utils/resources";

import defaultResourcesBokmaal from "./HN.Oppgave.Frontend.nb-NO.json";
import defaultResourcesNynorsk from "./HN.Oppgave.Frontend.nn-NO.json";
import defaultResourcesEnglish from "./HN.Oppgave.Frontend.en-GB.json";

export function getResourcesTestHelper(): HNOppgaveFrontend {
  return getModifiedResourcesForTest(
    defaultResourcesBokmaal,
  ) as HNOppgaveFrontend;
}

export const getBundledResources = (
  projectName: string,
  language: LanguageLocales,
): HNOppgaveFrontend | undefined => {
  if (projectName === oppgaveFrontendProject) {
    if (language === LanguageLocales.NORWEGIAN_NYNORSK) {
      return {
        ...defaultResourcesBokmaal,
        ...defaultResourcesNynorsk,
      } as unknown as HNOppgaveFrontend;
    }

    if (language === LanguageLocales.ENGLISH) {
      return {
        ...defaultResourcesBokmaal,
        ...defaultResourcesEnglish,
      } as unknown as HNOppgaveFrontend;
    }

    if (language === LanguageLocales.NORWEGIAN) {
      return defaultResourcesBokmaal as unknown as HNOppgaveFrontend;
    }
  }
};

const fetchResources = async (
  projectName: string,
  language: LanguageLocales,
): Promise<HNOppgaveFrontend> => {
  try {
    const resources = await import(`./${projectName}.${language}.json`);

    return resources.default;
  } catch (error) {
    throw new Error(
      `Failed to load resources for ${projectName} in ${language}: ${error}`,
    );
  }
};

export const { resourcesApi, useResources } =
  createResourcesApi<HNOppgaveFrontend>({
    getBundledResources: getBundledResources,
    fetchResources: fetchResources,
    fallbackLanguage: LanguageLocales.NORWEGIAN,
    useFallbackForMissingTexts: true,
  });
